// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__pKQvb","clouds":"styles_clouds__mQFqf","dimBrightness":"styles_dimBrightness__jttBB"};